import React from "react";
import PublicProfileView from "../components/PublicProfileView";

export default function UserProfile() {
  return <PublicProfileView />;
}
